export default "__VITE_ASSET__98adCmK6__"